import { webToCatchFaceConnect } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace/webToCatchFaceConnect'
import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const w32Web = async (
  ctx: CanvasRenderingContext2D,
  edgeColor: string,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1, printLeatherTypeValue)

  // 縦パーツ
  const drawVerticalPath = () => {
    ctx.beginPath()
    ctx.moveTo(614, 102) //左上
    ctx.quadraticCurveTo(595, 158, 571, 220) //左下
    ctx.quadraticCurveTo(591, 240, 605, 275) //右下
    ctx.quadraticCurveTo(685, 200, 685, 200) //右上
    ctx.quadraticCurveTo(650, 141, 614, 102) //左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawVerticalPath, webColor2 || webColor)

  // ヘリ革パーツ
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(614, 102) //左上
  ctx.quadraticCurveTo(571, 220, 571, 220) //左下
  ctx.quadraticCurveTo(577, 227, 579, 229) //右下
  ctx.quadraticCurveTo(623, 112, 623, 112) //右上
  ctx.quadraticCurveTo(627, 117, 614, 102) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(675, 193) //左上
  ctx.quadraticCurveTo(600, 265, 600, 265) //左下
  ctx.quadraticCurveTo(605, 274, 605, 274) //右下
  ctx.quadraticCurveTo(685, 200, 685, 200) //右上
  ctx.quadraticCurveTo(675, 193, 675, 193) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左
  ctx.moveTo(623, 113) // 上
  ctx.quadraticCurveTo(606, 167, 580, 228) // 下
  // // 縦向き＿右
  ctx.moveTo(678, 186) // 上
  ctx.quadraticCurveTo(600, 265, 600, 265) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -30, 20)
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, 25, -54) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -20, 20) // 捕球面寄りのウェブ結び目
}
